export default __webpack_public_path__ + "static/media/nflStaff4.f426facc.jpg";